const firebaseURL = 'https://react-hooks-update-ebf12.firebaseio.com';

export default firebaseURL;